import React from 'react';
import { EventsGroupViewCompetition } from 'src/domains/sportsbook/state/eventsListState/eventsGroup/EventsGroupView';
import { EventsListState } from './EventList.state';
import { EventsListCompetitionGroupItem } from './EventsListCompetitionGroupItem';
import { observer } from 'src/utils/mobx-react';
import { CompetitionWrapper } from './EventList.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface EventsListCompetitionGroupPropsType {
    competitions: readonly EventsGroupViewCompetition[];
    filterMarketsByPopularTag: boolean;
    state: EventsListState;
    wrapperKey: string;
}

export const EventsListCompetitionGroup = observer(
    'EventsListCompetitionGroup',
    (props: EventsListCompetitionGroupPropsType) => {
        const { competitions, filterMarketsByPopularTag, state, wrapperKey } = props;
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;
        return (
            <CompetitionWrapper
                variant={configState.componentVariants.sportsbookVariant}
                data-test='competitions-and-events'
                key={wrapperKey}
            >
                {competitions.map((competitionGroup) => (
                    <EventsListCompetitionGroupItem
                        competitionGroup={competitionGroup}
                        filterMarketsByPopularTag={filterMarketsByPopularTag}
                        key={`competition_group_item_${competitionGroup.id}`}
                        state={state}
                    />
                ))}
            </CompetitionWrapper>
        );
    }
);
